import React, {Fragment, useEffect} from 'react'

// Material-UI Core
import {withStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const WirsMsgTypography = withStyles({
	root: {
		"fontSize": 18,
		"fontWeight": 400,
		"color": "#0000b3",
	},
}) (Typography)

const Wirs = () => {
	const store = require('store')
	const wirsURL = process.env.REACT_APP_WIRS_URL

	const loadWirs = () => {
		window.open(wirsURL, '_blank')
	}
	
	// const loadWirs = () => {
	// 	let mapForm = document.createElement("form")
	// 	mapForm.target = "_blank"
	// 	mapForm.method = "POST"
	// 	mapForm.action = process.env.REACT_APP_WIRS_URL
	
	// 	let mapInput = document.createElement("input")
	// 	mapInput.type = "text"
	// 	mapInput.name = "token"
	// 	mapInput.value = store.get('access_token')
	// 	mapForm.appendChild(mapInput)
	
	// 	document.body.appendChild(mapForm)
	// 	mapForm.submit()
	// 	document.body.removeChild(mapForm)
	// }

	useEffect(() => {
		loadWirs()
	}, [])

	return (
		<Fragment>
			<WirsMsgTypography>
				Works Inspection Recording System (WIRS) open on new tab
			</WirsMsgTypography>
		</Fragment>
	)
}

export default Wirs